export default async function extractJson(response) {
  const contentType = response.headers.get('content-type');
  return contentType && contentType.includes('application/json') ? response.json() : {};
}